import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2C2.375 2 1 3.25 1 12s1.375 10 11 10 11-1.25 11-10S21.625 2 12 2M6 8.9V7.1h12v1.8zm6 4H6v-1.8h6z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesFilledSize24Glyph.displayName = 'CardLinesFilledSize24Glyph';
